import { Component, OnInit } from '@angular/core';
import { SettingsService } from '../../../core/settings/settings.service';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { CustomValidators } from 'ng2-validation';
import { AuthService } from '../auth.service';
import { Router } from '@angular/router';

import { IUserLogin } from '../user';

@Component({
    selector: 'app-login',
    templateUrl: './login.component.html',
    styleUrls: ['./login.component.scss']
})
export class LoginComponent implements OnInit {

    valForm: FormGroup;
    errorMessage: string = '';
    public user: IUserLogin = {
        _id: "",
        username: "",
        password: ""
    };

    constructor(public settings: SettingsService, fb: FormBuilder, public authService: AuthService, public router: Router) {

        this.valForm = fb.group({
            'email': [null, Validators.compose([Validators.required, CustomValidators.email])],
            'password': [null, Validators.required]
        });

    }

    submitForm($ev, value: any) {
        $ev.preventDefault();
        for (let c in this.valForm.controls) {
            this.valForm.controls[c].markAsTouched();
        }
        if (this.valForm.valid) {
            console.log('Valid!');
            console.log(value);
            this.user.username = value.email;
            this.user.password = value.password;
            this.authService.login(this.user).subscribe(
            user => {
                this.user = user[0];
                this.router.navigateByUrl('/category/category-list');
            },
            error => {
                console.log(error);
                this.errorMessage = <any>error.msg;
            });
        }
    }

    ngOnInit() {
        this.authService.logout();
    }

}



// WEBPACK FOOTER //
// ./src/app/routes/auth/login/login.component.ts